// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form_update-role-form__nkpq8 .Form_update-button__tbRtv {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px;
}
.Form_update-role-form__nkpq8 .Form_management-scope-item__NZb0q {
  display: flex;
  background: white;
  padding: 10px 15px;
  border-radius: 10px;
}
.Form_update-role-form__nkpq8 .Form_management-scope-item__NZb0q .Form_management-scope__q3Imy img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.Form_update-role-form__nkpq8 .Form_management-scope-item__NZb0q .Form_management-scope-info__h9ptY {
  margin-left: 10px;
  color: #6f6f6f;
}
.Form_update-role-form__nkpq8 .Form_management-scope-item__NZb0q .Form_management-scope-info__h9ptY .Form_management-scope-name__Kr3Yi {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px !important;
}
.Form_update-role-form__nkpq8 .Form_permissions__Bu6AT {
  margin-left: 20px;
}
.Form_update-role-form__nkpq8 .Form_permissions__Bu6AT .Form_sub-permissions__J5plU {
  margin-bottom: 15px;
}
.Form_update-role-form__nkpq8 .Form_permissions__Bu6AT .Form_sub-permissions__J5plU .Form_title__DLEk1 {
  margin-bottom: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/RoleDetail/Form/Form.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;AAAJ;AAEE;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAEM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAAR;AAGI;EACE,iBAAA;EACA,cAAA;AADN;AAEM;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAAR;AAKE;EACE,iBAAA;AAHJ;AAII;EACE,mBAAA;AAFN;AAGM;EACE,6BAAA;AADR","sourcesContent":[".update-role-form {\n  .update-button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: 30px;\n  }\n  .management-scope-item {\n    display: flex;\n    background: white;\n    padding: 10px 15px;\n    border-radius: 10px;\n    .management-scope {\n      img {\n        width: 80px;\n        height: 80px;\n        border-radius: 10px;\n        object-fit: cover;\n      }\n    }\n    .management-scope-info {\n      margin-left: 10px;\n      color: #6f6f6f;\n      .management-scope-name {\n        color: black;\n        font-weight: 600;\n        font-size: 16px;\n        margin-bottom: 5px !important;\n      }\n    }\n  }\n\n  .permissions {\n    margin-left: 20px;\n    .sub-permissions {\n      margin-bottom: 15px;\n      .title {\n        margin-bottom: 5px !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"update-role-form": `Form_update-role-form__nkpq8`,
	"update-button": `Form_update-button__tbRtv`,
	"management-scope-item": `Form_management-scope-item__NZb0q`,
	"management-scope": `Form_management-scope__q3Imy`,
	"management-scope-info": `Form_management-scope-info__h9ptY`,
	"management-scope-name": `Form_management-scope-name__Kr3Yi`,
	"permissions": `Form_permissions__Bu6AT`,
	"sub-permissions": `Form_sub-permissions__J5plU`,
	"title": `Form_title__DLEk1`
};
export default ___CSS_LOADER_EXPORT___;
